import { render, staticRenderFns } from "./appAdminCard.vue?vue&type=template&id=23fe7176&scoped=true"
import script from "./appAdminCard.vue?vue&type=script&lang=js"
export * from "./appAdminCard.vue?vue&type=script&lang=js"
import style0 from "./appAdminCard.vue?vue&type=style&index=0&id=23fe7176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fe7176",
  null
  
)

export default component.exports